module.exports = __webpack_public_path__ + "static/media/play-white.046e7f64.svg";